// Helper to format time display
export const formatTimeRange = (slot) => {
	const startH = slot.startHour;
	const startM = slot.startMinutes || 0;
	const totalEndMinutes = startH * 60 + startM + slot.durationMinutes;
	const endH = Math.floor(totalEndMinutes / 60);
	const endM = totalEndMinutes % 60;

	if (slot.label) return slot.label;

	const formatTime = (h, m) =>
		`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;

	return `${formatTime(startH, startM)} - ${formatTime(endH, endM)}`;
};

// Helper to format time from minutes since midnight (12-hour AM/PM format)
export const formatTimeFromMinutes = (minutes) => {
	const h = Math.floor(minutes / 60);
	const m = minutes % 60;
	const period = h >= 12 ? 'PM' : 'AM';
	const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
	const minStr = m === 0 ? '' : `:${m.toString().padStart(2, '0')}`;
	return `${hour12}${minStr}${period}`;
};

// Helper to get date string (using local timezone, not UTC)
export const getDateString = (date) => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

// Helper to check if a slot is on a specific date
export const isSlotOnDate = (slot, date) => {
	const dateStr = getDateString(date);
	if (slot.endDate) {
		return slot.startDate <= dateStr && slot.endDate >= dateStr;
	}
	return slot.startDate === dateStr;
};

// Helper to check if slot is within date range
export const isSlotInRange = (slot, startDate, endDate) => {
	const start = getDateString(startDate);
	const end = getDateString(endDate);
	const slotEnd = slot.endDate || slot.startDate;
	return slot.startDate <= end && slotEnd >= start;
};
